<ng-container *ngIf="!isDSD; else dsdClickToCall">
  <button
    appDisabledIfConseiller
    *ngIf="!isClickToCallBackEnabled || !clickToCallBackUrl"
    mat-button
    color="primary"
    [ngClass]="{
      'text-only': buttonStyle === 'textOnly',
      'text-and-icon': buttonStyle === 'textAndIcon',
      'boite-contact-button': buttonStyle === 'default' || buttonStyle === 'compactButton',
      'compact-button': buttonStyle === 'compactButton'
    }"
    (click)="contactButtonClick()"
    id="btn-click-to-call"
  >
    <ng-container [ngTemplateOutlet]="phoneIcon" *ngIf="buttonStyle === 'default' || buttonStyle === 'textAndIcon'">
    </ng-container>
    {{ buttonText | translate }}
  </button>

  <a
    appDisabledIfConseiller
    mat-button
    *ngIf="isClickToCallBackEnabled && clickToCallBackUrl"
    [ngClass]="{
      'text-only': buttonStyle === 'textOnly',
      'text-and-icon': buttonStyle === 'textAndIcon',
      white: buttonStyle === 'default' || buttonStyle === 'compactButton',
      little: buttonStyle === 'compactButton'
    }"
    [href]="clickToCallBackUrl"
    target="_blank"
    (click)="linkClick($event)"
    id="btn-click-to-call"
  >
    <ng-container [ngTemplateOutlet]="phoneIcon" *ngIf="buttonStyle === 'default' || buttonStyle === 'textAndIcon'">
    </ng-container>
    {{ buttonText | translate }}<span class="sr-only">&nbsp;{{ 'header.click-to-call.lien-externe' | translate }}</span>
  </a>

  <div
    class="boite-contact-tooltip"
    *ngIf="isTooltipVisible && buttonStyle !== 'textOnly' && buttonStyle !== 'textAndIcon'"
    [@enterAnimation]
  >
    <p class="texte">{{ 'header.click-to-call.texte' | translate }}</p>
    <div class="container-telephone">
      <div class="telephone-container">
        <a
          class="telephone principal dsd-mb-0"
          id="telephone-cta"
          href="tel:+1 {{ telephoneMontreal }}"
          title="{{ 'header.click-to-call.lien-telephonie' | translate }}"
          >{{ telephoneMontreal }}</a
        >
      </div>
      <div class="telephone-container sans-frais">
        <a
          class="telephone"
          id="telephone-sans-frais"
          href="tel:{{ telephoneSansFrais }}"
          title="{{ 'header.click-to-call.lien-telephonie' | translate }}"
          >{{ telephoneSansFrais }}</a
        >
        <div class="sans-frais">&nbsp;{{ 'header.click-to-call.sans-frais' | translate }}</div>
      </div>
    </div>
    <p [innerHTML]="'horaire.click-to-call' | translate" class="container-horaires"></p>
  </div>

  <ng-template #phoneIcon>
    <svg class="phone-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <path
        vector-effect="non-scaling-stroke"
        fill="none"
        stroke-width="1.5"
        stroke="currentColor"
        d="M6.646 9.274c1.6 3.145 3.113 4.588 6.258 6.2l1.885-.94c.582-.267.744-.4 1.133-.267 1.245.41 2.59.633 3.967.633.611 0 1.111.5 1.111 1.111v3.878C21 20.5 20.5 21 19.889 21 9.456 21 1 12.544 1 2.111 1 1.5 1.5 1 2.111 1H6c.611 0 1.111.5 1.111 1.111 0 1.389.222 2.722.633 3.967.123.389 0 .389-.277 1.133l-.821 2.063z"
      />
    </svg>
  </ng-template>
</ng-container>

<ng-template #dsdClickToCall>
  <dsd-button
    *ngIf="buttonStyle === 'default'"
    appDisabledIfConseiller
    (click)="buttonClick()"
    icon-position="start"
    icon-name="contenus_contour_par_telephone"
    full-width="xs"
    [srOnlySuffix]="'header.click-to-call.lien-externe' | translate"
    data-cy="link_click_to_call"
  >
    {{ buttonText | translate }}
  </dsd-button>

  <a
    appDisabledIfConseiller
    *ngIf="buttonStyle === 'textOnly'"
    href="#"
    (click)="buttonClick(); $event.preventDefault()"
    id="btn-click-to-call"
    class="text-only-decorated"
    data-cy="link_click_to_call"
  >
    {{ buttonText | translate }}<span class="sr-only">&nbsp;{{ 'header.click-to-call.lien-externe' | translate }}</span>
  </a>

  <dsd-link-action
    appDisabledIfConseiller
    *ngIf="buttonStyle === 'textAndIcon'"
    (click)="buttonClick(); $event.preventDefault()"
    data-cy="link_click_to_call"
    type="external"
  >
    <a href="#" (click)="$event.preventDefault()">{{ 'boite-contact.button-text-dsd' | translate }}</a>
  </dsd-link-action>

  <dsd-link-action
    appDisabledIfConseiller
    *ngIf="buttonStyle === 'arrowButtonPrimary'"
    variant="primary"
    (click)="buttonClick(); $event.preventDefault()"
    data-cy="link_click_to_call"
    type="external"
  >
    <a href="#" (click)="$event.preventDefault()">{{ 'boite-contact.button-text-dsd' | translate }}</a>
  </dsd-link-action>
</ng-template>
